export const CERTIFY_TRANSLATIONS = {
  en: {
    certify: {
      chatbot: {
        title: 'Talk to your data',
        subtitle: 'Welcome to the chatbot',
        welcome: {
          title: 'How can I help you today?',
          subtitle: 'Choose a question below or type your own',
          prompt: 'Or start typing below to add your own question',
          empty: 'No suggestions available at the moment',
          warning: 'You can store up to 30 conversations',
        },
        conversationLimit: {
          message: 'You have reached the maximum conversations open.',
          instruction: 'Please, erase one of your previous chats to create a new one',
          continue: 'Continue',
        },
        messages: {
          today: 'Today',
          yesterday: 'Yesterday',
        },
        history: {
          pinnedEmpty: 'No pinned conversations yet',
          actions: {
            pin: 'Pin',
            removePin: 'Remove Pin',
            rename: 'Rename',
            delete: 'Delete',
            menu: 'Conversation actions',
            openMenu: 'Conversation actions',
            renameInput: 'Conversation name',
          },
        },
        errors: {
          generic: 'Something went wrong. Please try again.',
        },
        timeAgo: {
          justNow: 'Just now',
          yesterday: 'Yesterday',
          minutes: '{{value}}m ago',
          hours: '{{value}}h ago',
          days: '{{value}}d ago',
          weeks: '{{value}}w ago',
        },
      },
    },
  },
  es: {
    certify: {
      chatbot: {
        title: 'Habla con tus datos',
        subtitle: 'Bienvenido al chatbot',
        welcome: {
          title: '¿Cómo puedo ayudarte hoy?',
          subtitle: 'Elige una pregunta o escribe la tuya',
          prompt: 'O escribe abajo para agregar tu propia pregunta',
          empty: 'No hay sugerencias disponibles por el momento',
          warning: 'Puedes almacenar hasta 30 conversaciones',
        },
        conversationLimit: {
          message: 'Has alcanzado el máximo de conversaciones abiertas.',
          instruction: 'Elimina uno de tus chats anteriores para crear uno nuevo',
          continue: 'Continuar',
        },
        messages: {
          today: 'Hoy',
          yesterday: 'Ayer',
        },
        history: {
          pinnedEmpty: 'Aún no hay conversaciones fijadas',
          actions: {
            pin: 'Fijar',
            removePin: 'Quitar fijación',
            rename: 'Renombrar',
            delete: 'Eliminar',
            menu: 'Acciones de la conversación',
            openMenu: 'Acciones de la conversación',
            renameInput: 'Nombre de la conversación',
          },
        },
        errors: {
          generic: 'Ocurrió un error. Inténtalo de nuevo.',
        },
        timeAgo: {
          justNow: 'Ahora mismo',
          yesterday: 'Ayer',
          minutes: 'Hace {{value}} min',
          hours: 'Hace {{value}} h',
          days: 'Hace {{value}} días',
          weeks: 'Hace {{value}} sem',
        },
      },
    },
  },
};
